export class State {
    public name: string;
    public element: React.JSX.Element;
    public onPresenceChange : ()=>void;

    constructor(name: string, element: React.JSX.Element, onPresenceChange: ()=>void = ()=>{}) {
        this.element = element;
        this.onPresenceChange = onPresenceChange;
        this.name = name;
    }
}